import { SNOWPLOW_CONFIG } from '../config/constants';
import { newTracker } from '@snowplow/browser-tracker';

const tracker = newTracker(SNOWPLOW_CONFIG.appName, 'https://snowplow.fpdc.dmed.technology', SNOWPLOW_CONFIG);
tracker.enableActivityTracking({
  minimumVisitLength: 10,
  heartbeatDelay: 10
});

console.log('Snowplow Tracker Initialized with App ID:', SNOWPLOW_CONFIG.appId)
export { tracker };
